import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../config/api';
import './AdminPages.css';
import './AdminAutomatedEmails.css';

const AdminAutomatedEmails = () => {
  const navigate = useNavigate();
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState(null);

  const fetchPayload = useCallback(async () => {
    try {
      const res = await api.get('/settings/automated-emails');
      setPayload(res.data);
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || 'Erreur lors du chargement des mails automatiques');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPayload();
  }, [fetchPayload]);

  const handleToggle = async (e, key) => {
    e.preventDefault();
    e.stopPropagation();
    if (!payload || savingKey) return;

    const next = !payload.types[key]?.enabled;
    setSavingKey(key);

    try {
      const res = await api.put(`/settings/automated-emails/${key}`, { enabled: next });
      setPayload(res.data);
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || 'Erreur lors de la mise à jour');
    } finally {
      setSavingKey(null);
    }
  };

  if (loading || !payload) {
    return (
      <div className="admin-container">
        <div className="loading">Chargement...</div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h1>Mailing automatique</h1>
        <Link to="/admin" className="btn-secondary">
          Retour tableau de bord
        </Link>
      </div>

      <p className="automated-emails-intro">
        Trois envois automatiques peuvent être activés ou désactivés individuellement. Cliquez sur une ligne pour
        éditer les versions française et italienne du message (sujet et contenu).
      </p>

      <div className="automated-emails-list">
        {payload.keys.map((key) => {
          const meta = payload.meta[key];
          const enabled = !!payload.types[key]?.enabled;

          return (
            <div
              key={key}
              role="button"
              tabIndex={0}
              onClick={() => navigate(`/admin/mailing-auto/edit/${encodeURIComponent(key)}`)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  navigate(`/admin/mailing-auto/edit/${encodeURIComponent(key)}`);
                }
              }}
              className={`automated-email-card ${savingKey === key ? 'automated-email-card--disabled' : ''}`}
            >
              <div className="automated-email-card-main">
                <h3>{meta?.labelFr || key}</h3>
                {meta?.labelIt && (
                  <p className="automated-email-card-sub">{meta.labelIt}</p>
                )}
                {meta?.hintFr && (
                  <p className="automated-email-card-hint">{meta.hintFr}</p>
                )}
              </div>
              <div className="automated-email-card-toggle-wrap" onClick={(e) => e.stopPropagation()}>
                <label className="toggle-switch" style={{ display: 'inline-block' }}>
                  <input
                    type="checkbox"
                    checked={enabled}
                    disabled={!!savingKey}
                    onChange={(e) => handleToggle(e, key)}
                  />
                  <span className="toggle-slider">{enabled ? 'Actif' : 'Inactif'}</span>
                </label>
              </div>
            </div>
          );
        })}
      </div>

      <p className="automated-emails-help">
        Les envois effectifs dépendront d&apos;une tâche serveur configurée séparément (non gérée sur cette page).
      </p>
    </div>
  );
};

export default AdminAutomatedEmails;
